import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonComponent } from '@components/common.component';
import moment from 'moment/moment';
import { combineLatest, filter, Observable, takeUntil, tap } from 'rxjs';
import { AsyncPipe, DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { EventCategory } from '@models/community/event-category.model';
import { eventsActions, selectEvents } from '@redux/events.effects';
import { EventCardComponent } from '@calendar/components/event-card/event-card.component';
import { EventFilter } from '@models/forms/event-filter.model';
import { ofType } from '@ngrx/effects';

@Component({
  selector: 'app-calendar-dashboard',
  standalone: true,
  imports: [
    RouterLink,
    SimplebarAngularModule,
    AsyncPipe,
    NgForOf,
    NgIf,
    DatePipe,
    NgClass,
    EventCardComponent,
  ],
  templateUrl: './calendar-dashboard.component.html',
  styles: ``,
})
export class CalendarDashboardComponent extends CommonComponent implements OnInit {
  mm = moment;

  //
  groups$: Observable<EventCategory[]> = this.store.select(selectEvents.selectFiltered);
  //
  ngOnInit(): void {
    combineLatest([this.community$, this.resident$])
      .pipe(
        filter(([community, resident]) => !!community && !!resident),
        tap(([community, resident]) => {
          const filter: EventFilter = {
            communityId: community!.id,
            residentId: resident!.id,
            careType: resident!.careType?.id,
            type: 'USER',
            startDt: moment().toDate(),
            group: [],
            activities: [],
            location: null,
            isRsvp: false,
            isHostedByMe: false,
            isCustomEvent: false,
            page: 1,
            size: 15,
          };
          this.store.dispatch(eventsActions.filter({ filter, reload: true }));

          this.actions$
            .pipe(
              ofType(
                eventsActions.attendSuccess,
                eventsActions.attendSuccess,
                eventsActions.unAttendSuccess,
                eventsActions.rsvpSuccess,
                eventsActions.unRsvpSuccess,
                eventsActions.rsvpWithGuestsSuccess,
                eventsActions.updateGuestsSuccess,
                eventsActions.deleteEvent,
                eventsActions.inviteSuccess,
                eventsActions.createFriendsSuccess,
                eventsActions.updateEventSuccess,
                eventsActions.createEventSuccess,
              ),
              takeUntil(this.destroy$),
            )
            .subscribe(() => {
              this.store.dispatch(eventsActions.filter({ filter, reload: true }));
            });
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
